import i18n from 'i18next';

/**
 * Get localized text from a multilingual object or return string as-is
 * @param {Object|string} textObj - Text object { en, tr, nl } or plain string
 * @param {string} [fallback=''] - Fallback text if nothing found
 * @returns {string}
 */
export const getLocalizedText = (textObj, fallback = '') => {
  if (!textObj || typeof textObj !== 'object') {
    return textObj || fallback;
  }

  const currentLang = i18n.language;
  return textObj[currentLang] || textObj['en'] || textObj[Object.keys(textObj)[0]] || fallback;
};
